import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { DEFAULTS, formatDocumentDate, TStringOrNull } from '../../../common';
import { getControlData } from '../../../utils';
import { IRecentDocument } from '../../services/documents';
import DocumentRoStatus from '../data/DocumentRoStatus';
import ViewDataDialog from '../data/ViewDataDialog';

interface IRecentDocumentListProps {
	documents: IRecentDocument[];
	isNotDraftEditor: boolean;
	indexBase: number;
	isFetching: boolean;
}
const RecentDocumentList = ({ documents, isNotDraftEditor, indexBase, isFetching }: IRecentDocumentListProps) => {
	const [activeDocumentId, setActiveDocumentId] = useState<TStringOrNull>(null);

	const onShowDocumentInfoClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
		const documentId = getControlData(event.target, '.link-button', 'documentId');
		if (!documentId) return;
		setActiveDocumentId(documentId as string);
	}, []);

	const onCloseDialog = useCallback(() => setActiveDocumentId(null), []);

	return (
		<>
			{documents.map(({ id, title, first_document_hash, insertion_date, user_code, status, editable }, index) => (
				<tr key={id} className={classNames('position-relative', indexBase !== 0 && index === 0 && 'tr-top-separator')}>
					<td>{indexBase + index + 1}.</td>
					<td>
						<Link
							to={`/${DEFAULTS.routes.doc}/${first_document_hash || id}`}
							className={classNames(
								isNotDraftEditor ? (editable ? 'link-primary' : 'link-secondary') : 'link-primary',
								'stretched-link'
							)}
							state={DEFAULTS.fromListState}
						>
							{title ?? 'Документ без назви'}
							{/* {editable === 1 && <BsPencilSquare className="ms-1" />} */}
						</Link>
					</td>
					<td className="d-none d-md-table-cell">
						<button
							className="link-button z-1 position-relative link-primary"
							data-document-id={id}
							onClick={onShowDocumentInfoClick}
						>
							<BsInfoCircle />
						</button>
					</td>
					<td className="d-none d-sm-table-cell">{formatDocumentDate(insertion_date)}</td>
					{/* {isNotDratEditor && <td>{user_code}</td>} */}
					<td className="d-none d-md-table-cell">{user_code}</td>
					<td>
						<DocumentRoStatus status={status} withTextColors withIcons />
					</td>
				</tr>
			))}
			{activeDocumentId && <ViewDataDialog documentId={activeDocumentId} handleClose={onCloseDialog} />}
		</>
	);
};

export default RecentDocumentList;
